/**
 * <about-video> — click-to-play video.
 * Shows a poster + play button; on click, swaps in the embed authored in the
 * section's <template data-av-template> (a Shopify video_tag or a YouTube/Vimeo
 * iframe with autoplay) so the video starts playing.
 */
class AboutVideo extends HTMLElement {
  connectedCallback() {
    this.playBtn = this.querySelector('[data-av-play]');
    this.media = this.querySelector('[data-av-media]');
    this.template = this.querySelector('[data-av-template]');
    if (!this.playBtn || !this.media || !this.template) return;
    this.playBtn.addEventListener('click', this.#play);
  }

  disconnectedCallback() {
    this.playBtn?.removeEventListener('click', this.#play);
  }

  #play = () => {
    const fragment = this.template.content.cloneNode(true);
    this.media.replaceChildren(fragment);
    this.setAttribute('playing', '');

    // Kick off playback for hosted <video> elements.
    const video = this.media.querySelector('video');
    if (video) {
      video.setAttribute('controls', '');
      const result = video.play();
      if (result && typeof result.catch === 'function') result.catch(() => {});
    }
  };
}

if (!customElements.get('about-video')) {
  customElements.define('about-video', AboutVideo);
}
